import { render, staticRenderFns } from "./xqlist.vue?vue&type=template&id=773ce34e&scoped=true"
import script from "./xqlist.vue?vue&type=script&lang=js"
export * from "./xqlist.vue?vue&type=script&lang=js"
import style0 from "./xqlist.vue?vue&type=style&index=0&id=773ce34e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ce34e",
  null
  
)

export default component.exports